import type { TabClaimPayload } from './amcf-tab-coordinator.models';

/**
 * Restituisce il claim vincente: scheda più nuova (`openedAt` maggiore).
 * A parità vince il `tabId` lessicograficamente maggiore.
 */
export function pickWinnerClaim(a: TabClaimPayload, b: TabClaimPayload): TabClaimPayload {
  if (a.openedAt !== b.openedAt) {
    return a.openedAt > b.openedAt ? a : b;
  }
  return a.tabId >= b.tabId ? a : b;
}

export function isClaimWinner(claim: TabClaimPayload, other: TabClaimPayload): boolean {
  return pickWinnerClaim(claim, other).tabId === claim.tabId;
}
